export default "<app-consulta-lecturas [simulacion]=\"true\"></app-consulta-lecturas>";